module.exports = __webpack_public_path__ + "0b70cd30ab7a0708ac281d07154bb0f6.png";